import type { Application } from '@/types/Activity'

export const hasIdentityData = (application: Application): boolean =>
  !!application.context?.identity
